import { useQuery } from '@apollo/client';
import { Tv } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';
import { AuditLogList } from '~/components/AuditLogs';
import { RouterBreadcrumbs } from '~/components/RouterBreadcrumbs';
import { ScrollableRouterTabs } from '~/components/RouterTabs';
import { PageContainer } from '~/components/page-layout';
import { Toolbar } from '~/components/toolbar';
import { useAppContext } from '~/contexts';
import { useLink } from '~/hooks/link';
import { NetworkTvBrandAuditLogsDocument } from '../queries/AuditLogs.generated';
import { useTabs } from './lib/tabs';

export const TVBrandAuditLogs = () => {
  const { t } = useTranslation();
  const params = useParams<{ tvBrandId: string }>();
  const tvBrandId = parseInt(params.tvBrandId ?? '');

  const { currentNetwork } = useAppContext();
  const link = useLink();

  const tabs = useTabs();

  const { data, loading } = useQuery(NetworkTvBrandAuditLogsDocument, {
    variables: { networkId: currentNetwork.id, tvBrandId },
  });

  const tvBrand = data?.network?.tvBrand;

  if (loading || !tvBrand) return !loading ? <Navigate to={link('/not-found')} replace /> : null;

  return (
    <>
      <Toolbar
        breadcrumbsLabel={<RouterBreadcrumbs />}
        titleIcon={<Tv />}
        titleText={tvBrand.name}
      />

      <ScrollableRouterTabs current={t('common.tabs.audit_logs')} tabs={tabs} />

      <PageContainer>
        <AuditLogList recordTypes={['TVBrand']} tvBrandId={tvBrandId} />
      </PageContainer>
    </>
  );
};
